import { ProductType } from '@tink/core/src/types';
import { validateExternalReference, ValidateProductParams } from '../../utilities/urlParameters';

export const validateParams: ValidateProductParams = ({ externalReference }) => {
  const errors = [];

  const externalReferenceError = validateExternalReference(externalReference || '');

  if (externalReferenceError) {
    errors.push(externalReferenceError);
  }

  return {
    parameters: {
      productType: ProductType.BUSINESS_ACCOUNT_CHECK,
      refreshableItems: [], // It's grabbed from the reports describe api
    },
    errors,
  };
};
